export default {
  CarBookingForm__ADVANCED_SEARCH_LINK: "Advanced search",
  CarBookingForm__CLOSE: "Close",
  CarBookingForm__COMPACT: "Compact",
  CarBookingForm__COMPACT_SUV: "Compact SUV",
  CarBookingForm__CONVERTIBLE: "Convertible",
  CarBookingForm__DATE_FORMAT: "MM/DD/YYYY",
  CarBookingForm__DAY_OF_WEEK_MONTH_AND_YEAR: "ddd, MMM DD, YYYY",
  CarBookingForm__DAYS_OF_WEEK_INITIALS: "SMTWTFS",
  CarBookingForm__DEPART_BUTTON_TEXT: "DEPART",
  CarBookingForm__DRIVING_AGE_25_AND_OLDER: "25+",
  CarBookingForm__DRIVING_AGE_LABEL: "Driver age*",
  CarBookingForm__DRIVING_AGE_TOOLTIP: "Young renter fee applied if under 25",
  CarBookingForm__DRIVING_AGE_UNDER_25: "Under 25",
  CarBookingForm__ECONOMY: "Economy",
  CarBookingForm__FULLSIZE: "Full-size",
  CarBookingForm__FULLSIZE_SUV: "Full-size SUV",
  CarBookingForm__FULLSIZE_VAN: "Full-size Van",
  CarBookingForm__INVALID_ROUTE: "Invalid route",
  CarBookingForm__JEEP: "Jeep/All Terrain",
  CarBookingForm__LUXURY: "Luxury",
  CarBookingForm__LUXURY_SUV: "Luxury SUV",
  CarBookingForm__MIDSIZE: "Mid-size",
  CarBookingForm__MIDSIZE_SUV: "Mid-size SUV",
  CarBookingForm__MINIVAN: "Minivan",
  CarBookingForm__NO_MATCH_FOUND: "No match found",
  CarBookingForm__PICKUP_DATE_LABEL: "Pick-up date*",
  CarBookingForm__PICKUP_DATE_ARIA: "Pickup date in M M, D D format",
  CarBookingForm__PICKUP_DATE_SELECTOR_TITLE: "Select pick-up date",
  CarBookingForm__PICKUP_LOCATION_ARIA: "Pick-up location",
  CarBookingForm__PICKUP_LOCATION_LABEL: "Pick-up location*",
  CarBookingForm__PICKUP_TIME_ARIA: "Pick-up time",
  CarBookingForm__PICKUP_TIME_LABEL: "Pick-up time*",
  CarBookingForm__PICKUP_TRUCK: "Pick-up Truck",
  CarBookingForm__PREMIUM: "Premium",
  CarBookingForm__PREMIUM_SUV: "Premium SUV",
  CarBookingForm__RECENT_SEARCHES_LABEL: "Recent searches",
  CarBookingForm__RENTAL_COMPANY: "Rental company",
  CarBookingForm__RETURN_BUTTON_TEXT: "RETURN",
  CarBookingForm__RETURN_DATE_LABEL: "Return date*",
  CarBookingForm__RETURN_DATE_ARIA: "Return date in M M, D D format",
  CarBookingForm__RETURN_DATE_SELECTOR_TITLE: "Select return date",
  CarBookingForm__RETURN_LOCATION_ARIA: "Return location",
  CarBookingForm__RETURN_LOCATION_LABEL: "Return location*",
  CarBookingForm__RETURN_TIME_ARIA: "Return time",
  CarBookingForm__RETURN_TIME_LABEL: "Return time*",
  CarBookingForm__SELECT_DATE_TEXT: "Select date",
  CarBookingForm__SHORT_DATE_MONTH_AND_DAY_FORMAT: "MM/DD",
  CarBookingForm__SPORT: "Sport",
  CarBookingForm__STANDARD_ELITE_SUV: "Std. Elite SUV",
  CarBookingForm__STANDARD_SUV: "Standard SUV",
  CarBookingForm__SUBMIT_BUTTON: "Search cars",
  CarBookingForm__TEXT_ALL_OTHERS: "All Others",
  CarBookingForm__TEXT_ALL_RAPID_REWARDS_PARTNERS: "All Rapid Rewards Partners",
  CarBookingForm__TEXT_ALL: "All",
  CarBookingForm__TEXT_SUBJECT_TO_CHANGE:
    "This date is subject to change! Please check back frequently.",
  CarBookingForm__VEHICLE_SIZE: "Vehicle size",
};
